/* KOMTO mobile menu: under each category with children, list the sub-collections
   ("Shoe benches · Shoe cabinets · Shoe racks") so the list reads like the canvas. */
(function () {
  document.querySelectorAll('.main-nav .child-nav > li.child-nav__item--toggle').forEach(function (li) {
    if (li.querySelector('.komto-nav-sub')) return;
    var names = Array.prototype.map.call(li.querySelectorAll('.main-nav__grandchild .main-nav__item'), function (a) { return a.textContent.trim(); }).filter(Boolean);
    var link = li.querySelector(':scope > .main-nav__item-content > .main-nav__item, :scope > .main-nav__item-content .main-nav__item');
    if (!names.length || !link) return;
    var s = document.createElement('span'); s.className = 'komto-nav-sub'; s.textContent = names.join(' · ');
    link.appendChild(s);
  });
})();
